import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  payments: [],
  isLoading: false,
  isError: false,
  message: "",
};

const paymentSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    allRecords: (state, action) => {
    state.payments = action.payload; 
    state.isLoading = false;
},
    recordPaymentStart: (state) => {
      state.isLoading = true;
    },
    recordPaymentSuccess: (state, action) => {
      state.isLoading = false;
      state.isError = false;
      // Adds the new payment to the list
      state.payments.push(action.payload);
    },
    updatePayment: (state, action) => {
      state.isLoading = false;
      state.isError = false;
      const updated = action.payload;
      const index = state.payments.findIndex((pay) => pay.id === updated.id);
      if (index !== -1) {
        state.payments[index] = { ...state.payments[index], ...updated };
      }
    },
    removePayment: (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.payments = state.payments.filter((pay) => pay.id !== action.payload);
    },
    recordPaymentFailure: (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload;
    },
    resetPaymentState: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.message = "";
    }
  },
});

export const { 
    allRecords,
  recordPaymentStart, 
  recordPaymentSuccess, 
  updatePayment,
  removePayment,
  recordPaymentFailure,
  resetPaymentState 
} = paymentSlice.actions;

export default paymentSlice.reducer;